module.exports = __webpack_public_path__ + "static/media/chevron_left.afb36c7c.svg";